import { useMutation } from '@tanstack/react-query';
import type {
  TProjectOperation,
  TProjectPayload,
  TProjectScope,
} from '#providers/projects/Projects.types.ts';
import { useInvalidateQueries } from '#providers/query/index.ts';

export const useProjectMutation = <
  TPayload extends Partial<TProjectScope>,
  TResult,
>(
  operation: ((payload: TPayload) => Promise<TResult>) &
    TProjectOperation<TPayload, TResult>,
  requireProjectId: () => string,
  invalidates: readonly (readonly unknown[])[],
) => {
  const invalidateQueries = useInvalidateQueries();

  return useMutation({
    mutationFn: (payload: TProjectPayload<TPayload>) =>
      operation({ ...payload, project_id: requireProjectId() }),
    onSuccess: () => invalidateQueries(...invalidates),
  });
};
